import { clone, ISpineData, SpineBase, detectDeviceEnvironmentConstants, dispatcher, IEvent, ingenuity, IObject, Graphics, Container } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, View } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { SlotConstants } from "@quest/slot-core";

export class BaseGameViewGame extends View {
  constructor(json: any) {
    super(json);
    ingenuity.deviceEnv.isDesktop && (this.getImageById("reelBG").mask = this.getShapeById("reelMask"));
  }
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.CREATE_WIN_MASK, this.maskWinLayer, this);
  }
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.CREATE_WIN_MASK, this.maskWinLayer, this);
  }
  /**
      * to add mask on win presentation layer
      */
  private maskWinLayer(): void {
    const winPanel = this.getWinReelView();
    for (let i = 0; i < ingenuity.configData.numberOfReel; i++) {
      winPanel.children[i].mask = this.getShapeById("winMasker") as Graphics
    }
  }


  protected resizeOrientation(e?: IObject): void {
    super.resizeOrientation();
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER) + (gameConstants.PORTRAIT_SHIFT_X * this.scale.x);
    }
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.ALLIGN_PROGRESS_BALLS_BASEGAME)
  }
  /**
  * overrided to avoid symbol fade as per game
  */
  public landingAnimation(data: any) {
    const [reelgrid, reelview, reelId] = data;
    for (let i = 0; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const staticSym = reelview.getSymbolByPos(reelId, i).getStatic();
        const animSym = reelview.getSymbolByPos(reelId, i).getAnimation();
        if (animSym) {
          if (staticSym.parent) {
            staticSym.visible = false;
            animSym.visible = true;
            staticSym.parent.addChild(animSym);
            const anim = animSym.json.animations.landing ? animSym.json.animations.landing : "landing";
            const staticAnim = animSym.json.animations.static ? animSym.json.animations.static : "static";
            animSym.playAnim(staticAnim, false);
            animSym.onComplete.addOnce(() => {
              animSym.playAnim(anim, false);
            }, this);
          }
        }
      }
    }
  }
  /** to show alpha on symbol*/
  protected showAlpha(): void {
    if (this.reelView) {
      for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
        for (let symbol = 0; symbol < 10; symbol++) {
          if ((this.reelView.getSymbolByPos(reel, symbol).getStatic().num !== gameConstants.RESPIN_TRIGGER_SYM)) {
            this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0x5b5b5b;
          }
        }
      }
    }
  }

  /**
   * to hide all symbols alpha which are present on grid
   */
  protected hideAlpha(): void {
    if (this.reelView) {
      for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
        for (let symbol = 0; symbol < 10; symbol++) {
          this.reelView.getSymbolByPos(reel, symbol) && (this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0xffffff);
          const anim = this.reelView.getSymbolByPos(reel, symbol)?.getAnimation() as any;
          if (anim !== undefined) {
            anim.tint = 0xffffff;

          }
        }
      }
    }
  }

  /**
   * to hide symbols alpha which are part of winning line
   */
  protected hideAlphaOnWinSymbol(evt: IEvent): void {
    if (this.reelView) {
      this.showAlpha();
      if (evt === null || evt === void 0 ? void 0 : evt.data) {
        for (const winSymData of evt.data) {
          this.reelView.getSymbolByPos(winSymData[0], winSymData[1]).getStatic().tint = 0xffffff;
          const anim = this.reelView.getSymbolByPos(winSymData[0], winSymData[1]).getAnimation() as any;
          if (anim !== undefined) {
            anim.tint = 0xffffff;
          }
        }
      }
    }
  }
  /**
   *  
   * create symbol clone
   */
  public createSymbol(id: string): SpineBase {
    const revealSpineObj: ISpineData = clone(this.json[id]);
    revealSpineObj.type = "spine";
    const revealSymSpine: SpineBase = this.createSpine(revealSpineObj);
    revealSymSpine.visible = true;
    return revealSymSpine;
  }
  /**
   * overrided to handle layering between buttons controller and portritbuttonController
   */
  protected addButtonPanelOnTop() {
    this.getContainerByID("portraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("portraitButtonsContainer"));
    const buttonsContainer = this.getContainerByID("buttonsContainer");
    ingenuity.currentGame.stage.addChild(buttonsContainer);
    const buttonsContainerWidth = buttonsContainer.width;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
      buttonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      const scale = Math.min((window.innerHeight / ingenuity.configData.height), (window.innerWidth / ingenuity.configData.width));
      buttonsContainer.x = (buttonsContainer.width / 2) + ((window.innerWidth - buttonsContainerWidth) / 2);
      buttonsContainer.y = window.innerHeight - (this.getImageById("Button_Panel_Base").height * scale);
      buttonsContainer.scale.set(scale, scale);
    }
    else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      buttonsContainer.scale.set(this.portraitPanelScaling());
      const bottomPanelBgPortrait = this.getImageById("Button_Panel_BasePort");
      bottomPanelBgPortrait && buttonsContainer.pivot.set(bottomPanelBgPortrait.width / 2, bottomPanelBgPortrait.height);
      buttonsContainer.x = window.innerWidth / 2;
      buttonsContainer.y = window.innerHeight;
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_TOP_BAR_ON_TOP);
  }
  public showAnticipation(reel: number, callback?: () => void, callbackScope?: any): void{
    if (typeof this.anticipationContainer === "undefined") {
      this.anticipationContainer = new Container(this.json, this.game);
      this.anticipationContainer.name = SlotConstants.AnticipationConatiner;
      this.addChild(this.anticipationContainer);
    }
    if (this.json.anticipationAnim) {
      const anticJson = this.json.anticipationAnim;
      anticJson.id = "anticipation";
      anticJson.type = "spine";
      const anticipation = this.createSpine(anticJson);
      if (anticipation) {
        anticipation.visible = true;
        this.anticipationContainer.addChild(anticipation);
        this.anticipationContainer.x = this.json.reels.reels[reel].x + this.json.reels.x + this.json.anticipationAnim.valueX;
        this.anticipationContainer.y = this.json.reels.reels[reel].y + this.json.reels.y + this.json.anticipationAnim.valueY;
        this.addChild(this.anticipationContainer);
        anticipation.playAnim("anticipation_1X4", true);
      }
    }
  }
}
